import { useTranslation } from "react-i18next";
import { Button } from "components/atoms";

const prefix = "o-workspace-changed-modal";

const WorkspaceChangedModal = () => {
  const { t } = useTranslation();

  return (
    <div className={prefix}>
      <div className={`${prefix}__content`}>
        {t("common:tabSync.workspaceChanged.message")}
      </div>

      <div className={`${prefix}__buttons`}>
        <Button
          content={t("common:tabSync.workspaceChanged.action")}
          onClick={() => window.location.assign("/")}
          sm
          type="purple"
        />
      </div>
    </div>
  );
};

export default WorkspaceChangedModal;
